module.exports = __webpack_public_path__ + "62370aa2434dd8d2062f342da1188946.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/anatomy-of-a-cell.svg
// module id = 803
// module chunks = 0